import React from 'react'
import { IMG_BASE_URL } from '../../../../config/Config'
import { Link } from 'react-router-dom'
import Instagram1 from '../../../../assets/img/instagram/instagram1.webp'
import Instagram2 from '../../../../assets/img/instagram/instagram2.jpg'
import Instagram3 from '../../../../assets/img/instagram/instagram3.jpg'
import Instagram4 from '../../../../assets/img/instagram/instagram4.jpg'
const Home_Letest_Post = (homeData) => {
    const letest_blog = homeData?.data?.blog
    const certificateBanner = homeData?.data?.certificate_data

    return (
        <div>
            <section className="bg-gray-100 relative">
                <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1200px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px] py-4">
                    {certificateBanner?.length > 0 && (
                        <>
                            {certificateBanner?.map((bannerItem, index) => (
                                <div key={index} className="gi-bl-block-content grid md:grid-cols-2 gap-5">

                                    <div className="gi-check-bill-form pb-4 my-auto">
                                        <div className="section-title-2 relative pb-6">
                                            <h1 className="text-gray-900 bodonibook_font text-3xl font-medium font-bold capitalize">{bannerItem?.certificate_title}</h1>
                                            <div className="border-b border-gray-600 mt-3 w-[150px]"></div>
                                        </div>

                                        <div className="flex gap-5 flex-wrap items-center">
                                            {bannerItem?.certificate_logo && JSON.parse(bannerItem?.certificate_logo)?.map((logo, logoIndex) => (
                                                <a href='/' target='blank' key={logoIndex}><img width={120} src={`${IMG_BASE_URL}${logo}`} alt="certificate-logo" /></a>
                                            ))}
                                        </div>
                                        <div className="gap-4 flex-wrap mt-6">
                                            <a className="text-[13px] mx-auto uppercase inline-block border border-gray-200 text-gray-800 font-semibold px-7 py-2.5 hover:bg-red-700 hover:text-white hover:border-red-700" href="/">Shop Now</a>
                                        </div>
                                    </div>
                                    <div>
                                        <img src={`${IMG_BASE_URL}${bannerItem?.certificate_image}`} className='rounded-lg' alt="gemstone-certificate" />
                                    </div>
                                </div>
                            ))}
                            {/* <---------- Certificate section's -------------> */}

                        </>
                    )}

                </div>
            </section>
            <section className="gi-blog-section py-[40px] max-[767px]:py-[30px] wow fadeInUp">
                <div
                    className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1200px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                    <div className="w-full flex flex-wrap px-[12px]">
                        <div className="gi-tab-title grid md:grid-cols-3 gap-3 items-center w-full mb-5">
                            <div></div>
                            <div className="section-detail text-center">
                                <h2
                                    className="bodonibook_font text-3xl text-gray-900 font-bold capitalize">
                                    Latest <span className="text-[#9F2225]">Blogs</span></h2>
                                <p className="mt-[5px] text-[12px] font-semibold text-gray-900 capitalize">Explore our award
                                    winning blogs</p>
                            </div>
                            <div className='text-center md:text-end'>
                                <Link to="/blogs"
                                    className="text-[13px] uppercase border border-gray-400 text-gray-900 font-semibold px-6 py-3 hover:bg-red-700 hover:text-white">
                                    View All</Link>
                            </div>
                        </div>
                        <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
                            {
                                letest_blog?.slice(0, 2)?.map((letest_blog_result) => {
                                    return (
                                        <div onClick={() => localStorage.setItem("letest_blog_result_id", letest_blog_result?.id)}>
                                            <Link to={`/blog/${letest_blog_result?.slug}`}>
                                                <div className="gi-blog-item">
                                                    <div
                                                        className="grid grid-cols-1 lg:grid-cols-2 gap-3 blog-info transition-all duration-[0.3s] ease-in-out w-full mb-[24px] bg-[#fff] shadow-custome">
                                                        <figure className="blog-img w-full h-auto m-[0] flex relative overflow-hidden">

                                                            <img
                                                                src={`${IMG_BASE_URL}${letest_blog_result?.image}`}
                                                                alt={letest_blog_result?.alt_image_title}
                                                                className="w-full h-[200px] sm:h-[250px] lg:h-full lg:w-full object-cover bg-white"
                                                            />

                                                        </figure>
                                                        <div className="detail w-full my-auto p-4">
                                                            <h3 className="text-[15px] mb-2 leading-[26px] font-semibold text-gray-900"><Link to={`/blog/${letest_blog_result?.slug}`}
                                                                className="font-semibold leading-[22px] line-clamp-1">{letest_blog_result?.title}</Link></h3>
                                                            <div className="sub__title line-clamp-3 text-[12px] font-medium" dangerouslySetInnerHTML={{ __html: letest_blog_result?.long_description }} />
                                                            <div className="more-info mt-6">
                                                                <Link to={`/blog/${letest_blog_result?.slug}`} className="text-[13px] uppercase border border-gray-400 text-gray-900 font-semibold px-6 py-3 hover:bg-red-700 hover:text-white">Read
                                                                    More</Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>

                                    )
                                })
                            }

                        </div>
                    </div>
                </div>
            </section>
            <section className="gi-deal-section wow fadeInUp" data-wow-duration="2s">
                <div
                    className="flex flex-wrap justify-between items-center mx-auto min-[1600px]:max-w-[1450px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                    <div className="w-full flex flex-wrap px-[12px] overflow-hidden">
                        <div className="gi-deal-section w-full">
                            <div className="gi-products">
                                <div className="gi-tab-title grid md:grid-cols-3 gap-3 items-center w-full mb-5">
                                    <div className="section-detail"></div>
                                    <div className="section-detail text-center">
                                        <h2 className="bodonibook_font text-2xl text-gray-900 font-bold uppercase">@Instagram123</h2>
                                        <p className="mt-[5px] text-[14px] font-semibold text-gray-700 uppercase">Omens Designs Instagram images will be injected here dynamically</p>
                                    </div>

                                </div>
                                <div className="gi-deal-block" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="300">
                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                                        <div
                                            className="gi-products bg-no-repeat text-center relative cursor-pointer shadow-custome my-4">
                                            <div className="relative"><img
                                                src={Instagram1}
                                                className="h-[450px] object-fit w-full mx-auto" alt="product_image" />

                                            </div>
                                        </div>
                                        <div
                                            className="gi-products bg-no-repeat text-center relative cursor-pointer shadow-custome my-4">
                                            <div className="relative"><img
                                                src={Instagram2}
                                                className="h-[450px] object-fit w-full mx-auto" alt="product_image" />

                                            </div>
                                        </div>
                                        <div
                                            className="gi-products bg-no-repeat text-center relative cursor-pointer shadow-custome my-4">
                                            <div className="relative"><img
                                                src={Instagram3}
                                                className="h-[450px] object-fit w-full mx-auto" alt="product_image" />

                                            </div>
                                        </div>
                                        <div
                                            className="gi-products bg-no-repeat text-center relative cursor-pointer shadow-custome my-4">
                                            <div className="relative"><img
                                                src={Instagram4}
                                                className="h-[450px] object-fit w-full mx-auto" alt="product_image" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Home_Letest_Post